<template>
  
  <div class="animated fadeIn align-middle">

    <b-card id="content" class="bg-white">

      <b-row>

        <b-col class="col-2">
          <b-img src="img/ata.png" fluid alt="Logo de ATA Cloud"></b-img>
        </b-col>

        <b-col class="align-self-center">
          <h2>ATA AUTÓNOMOS | Mis preferencias</h2>
        </b-col>

      </b-row>

      <b-row class=" mt-4">
        <b-col>
          <h4 class="text-primary">
            {{ statusText }}
          </h4>

          <b-form-checkbox-group
            v-model="selectedCampaignTypes"
            id="selectedCampaignTypes"
            v-if="status !== true"
          >
            <b-form-checkbox
              v-for="campaignType in campaignTypes"
              :key="campaignType.uuid"
              :value="campaignType.uuid"
              class="my-3"
            >
              {{ campaignType.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
          <b-button v-if="status !== true" @click="unsubscribeClient(selectedCampaignTypes)" variant="primary" class="mt-2">
            Darse de Baja
          </b-button>
        </b-col>
      </b-row>

    </b-card>

  </div>

</template>

<script>

import {unsubscribeClient} from "@/api/client-api";
import {getPublicCampaignTypes} from "@/api/campaign-type-api";

export default {
  name: "unsubscribeClient",

  data() {
    return {
      status: false,
      statusText: "Selecciona las listas de las que deseas darte de baja",
      apiResponse: null,
      campaignTypes: [],
      selectedCampaignTypes: [],
    };
  },

  created() {
    this.getCampaignTypes();
  },

  methods: {
    async getCampaignTypes() {
      this.$_loadingMixin_showLoading();
      await getPublicCampaignTypes()
        .then((campaignTypes) => {
          this.campaignTypes = campaignTypes.campaignTypes;
        });
      this.$_loadingMixin_hideLoading();
    },
    async unsubscribeClient(selectedCampaignTypes) {
      if (!selectedCampaignTypes || selectedCampaignTypes.length === 0) {
        return;
      }

      const token = this.$route.query.token;
      const emailSentId = this.$route.query.emailSentId;

      const requestObject = {
        data: {
          token: token,
          emailSentId: emailSentId,
          campaignTypeUuids: selectedCampaignTypes,
        },
      };
      this.$_loadingMixin_showLoading();

      unsubscribeClient(requestObject)
        .then((response) => {
          this.$_loadingMixin_hideLoading();
          this.apiResponse = response;
          if (response.status === 200){
            this.status = true;
            this.statusText = "Tus preferencias han sido actualizadas";
          }
        })
        .catch((error) => {
          this.$_loadingMixin_hideLoading();
        });
    },
  },
}
</script>
